import React from 'react';
import Header from '../Header/Header';


const MyBlog = () => {
    return (
        <div>
            <Header></Header>
            <div className='pt-16 min-h-screen flex justify-center items-center'>
                <div className='bg-gray-300 w-72 text-black p-10 rounded-md'>My Blog Comming Soon</div>
            </div>
        </div>
    );
};

export default MyBlog;